"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = require("owa-strings");
var weatherSpriteStyles = require('owa-sprite/dist/styles/weather_sprite.css');
// 0 is the fallback 'unknown' image.
function getWeatherImage(skyCodeId) {
    if (skyCodeId === void 0) { skyCodeId = 0; }
    skyCodeId = skyCodeId < 4 || skyCodeId > 83 ? 0 : skyCodeId; // Set the valid ranges.
    return weatherSpriteStyles[owa_strings_1.format('weather-icon-SkyCode_32pct_{0}', skyCodeId)];
}
exports.default = getWeatherImage;
//# sourceMappingURL=getWeatherImage.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/utils/getWeatherImage.js
// module id = 3677
// module chunks = 48